let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1EhMp")).then(() => parcelRequire('2BQV1'));